// extracted by mini-css-extract-plugin
export var heroImage = "_ed-1";
export var modal = "_ed-0";